import React, { useState, useEffect } from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import {
  SimpleGrid,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Text,
} from "@chakra-ui/react";

import { CustomButton } from "../../../../../components/CustomButton";
import { FocusError } from "../../../../../components/FocusError";
import pt from "date-fns/locale/pt";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { hasFormChanged } from "../../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import CriancaService from "../../../../../../main/services/CriancaService";
import { CustomTextArea } from "../../../../../components/CustomTextArea";

const schema = Yup.object().shape({
  observacao: Yup.string(),
});

export const EditarSituacaoAdocaoModal = ({
  isOpen,
  onOpen,
  onClose,
  onCloseFiliacoes,
  form,
  idCrianca,
  fetchProcessosProcedimentoData,
  fetchAdocaoData,
  dataAdocao,
}) => {
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);
  const {
    cadastrarProcessosProcedimentos,
    setCadastrarProcessosProcedimentos,
  } = useAppContext();

  const [initialValues, setInitialValues] = useState({
    observacao: "",
  });

  useEffect(() => {
    setInitialValues({
      observacao: dataAdocao?.observacao ? dataAdocao?.observacao : "",
    });
  }, [dataAdocao]);

  const backAlert = () => {
    if (cadastrarProcessosProcedimentos) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setCadastrarProcessosProcedimentos(false);
        }
      });
    } else {
      onClose();
    }
  };
  const editSituacaoAdocao = async (id, valuesToSend) => {
    try {
      await CriancaService.putSituacaoAdocao(id, valuesToSend);
      Swal.fire({
        title: "Sucesso!",
        text: "Registro atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {});
      onClose();
      fetchProcessosProcedimentoData();
      fetchAdocaoData();
    } catch (error) {
      console.log(error);
      const errorMessage = JSON.parse(error?.response?.data?.message);

      Swal.fire({
        title: "Atenção!",
        text: error?.response?.data?.message
          ? errorMessage?.processoProcedimentoDuplicado ||
            error.response.data.message
          : "",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    }
  };

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { observacao } = values;

      const valuesToSend = {
        observacao,
      };

      editSituacaoAdocao(idCrianca, valuesToSend);

      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {"Editar Situação quanto à adoção".toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(props) => (
                <Form style={{ width: "100%" }}>
                  {setCadastrarProcessosProcedimentos(
                    hasFormChanged(initialValues, props.values)
                  )}

                  <FocusError />
                  <Grid templateColumns="repeat(6, 1fr) 1fr" gap={2}>
                    <GridItem colSpan={7}>
                      <Flex gap={2} opacity={"0.5"}>
                        <Text textAlign="justify">
                          <Text as="b">Cumpre Requisitos para Adoção?</Text>{" "}
                          {dataAdocao?.cumpreRequisitoAdocao === "S"
                            ? "Sim"
                            : "Não"}
                          {dataAdocao?.motivoAptoAdocao?.descricao
                            ? ` - ${dataAdocao?.motivoAptoAdocao?.descricao}`
                            : ""}
                        </Text>
                      </Flex>
                    </GridItem>
                    <GridItem colSpan={7} mt={2}>
                      <CustomTextArea
                        fieldName={"observacao"}
                        label={"Observações:"}
                        placeholder={"Informe as Observações"}
                        setIsTextareaFocused={setIsTextareaFocused}
                        maxLength={255}
                        isTextareaFocused={isTextareaFocused}
                        fontWeightLabel={700}
                      />
                    </GridItem>
                  </Grid>
                  <Flex justifyContent="end">
                    <SimpleGrid
                      mt="25px"
                      columns={2}
                      spacing="15px"
                      w={{ base: "100%", lg: "40%" }}
                    >
                      <CustomButton onClick={backAlert} label="Cancelar" />
                      <CustomButton
                        type="submit"
                        translate="no"
                        isLoading={props.isSubmitting}
                        label="Salvar"
                      />
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
